var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception-403"},[_c('exception',{attrs:{"title":403,"message":_vm.$vuetify.lang.t('$vuetify.exception.pages.403')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }